import React, {
  useEffect
} from 'react';
import mixpanel from '../utils/mixpanel';
import { MIXPANEL_ACTION } from '../utils/constants';

const usePageView = (page: string, params?: any) => {
  useEffect(() => {
    mixpanel.track(`${page} - ${MIXPANEL_ACTION.PAGE_VIEW}`, params);
  }, [])
}

export default usePageView;